import { LocaleAuth } from '../en/auth'

const auth: LocaleAuth = {
  heading: 'UNTUK Sukan, OLEH Sukan.',
  signIn: 'Log Masuk',
  forgotPass: 'Terlupa Kata Laluan?',
  claimQuestion: 'Baru sahaja dalam kejohanan?',
  claimAccount: 'Tuntut Akaun Anda',
  claimAccountDesc:
    'Sudah bermain dalam kejohanan atau liga? Anda mungkin sudah mempunyai profil pemain dan penarafan DUPR.',
  noAccount: 'Tiada akaun DUPR?',
  signUp: 'Daftar',
  createAccount: 'Cipta Akaun',
  createPassword: 'Cipta Kata Laluan',
  passInstructLength: 'Mesti mempunyai sekurang-kurangnya 6 aksara',
  passInstructStructure: 'Mesti mengandungi satu atau lebih nombor',
  forgotPassDesc: 'Masukkan e-mel berdaftar anda untuk menerima arahan menetapkan semula kata laluan.',
  checkYourEmail: 'Semak E-mel Anda!',
  resetCodeSentGeneric: 'Jika akaun wujud untuk alamat tersebut, kami telah menghantar kod 4 digit.',
  verifyEmailDesc:
    'Anda baru sahaja menerima kod untuk menetapkan semula kata laluan melalui e-mel. Masukkan kod 4 digit untuk meneruskan.',
  verifyYourNumber: 'Sahkan Nombor Anda',
  verifyPhoneNumberDesc: 'Kod 4-digit telah dihantar ke nombor telefon anda – masukkan di sini untuk pengesahan.',
  claimAccountHelpText: 'Taip nama anda di bar carian untuk mula mencari keputusan anda',
  notSeeYourself: 'Tidak jumpa nama anda di sini?',
  lastMatch: 'Perlawanan Terakhir',
  noMatchResult: 'Tiada keputusan perlawanan.',
  accAlreadyTaken: 'Akaun ini telah diambil',
  accAlreadyTakenModal:
    'Jika anda percaya ini adalah akaun anda dan telah dituntut oleh orang lain, sila hubungi pasukan sokongan kami',
  iAgreeToThe: 'Saya bersetuju dengan',
  termsOfService: 'Syarat Perkhidmatan',
  privacyPolicy: 'Dasar Privasi',
  acceptTerms: 'Sila terima Syarat Perkhidmatan untuk meneruskan',
  cookiePolicy: 'Dasar Kuki',
}

export default auth
